import { Text } from "@ui-kitten/components";
import React from "react";
import { View } from "react-native";
import { ScreenLayout } from "../common/layout/ScreenLayout";

export const NotLoggedInScreen = () => {
    return (
        <ScreenLayout scroll={false} title="Recipes">
            <View style={{ flex: 1, padding: 8 }}>
                <Text>Not logged in</Text>
            </View>
        </ScreenLayout>
    );
};
